import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import './navbar.css';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
<header className={`nav-container ${isScrolled ? "scrolled" : ""}`}>
  <Link to="/" className="nav-logo-link">
    <img
      src="/playground_assets/rl-logo.png"
      alt="Richmond Logo"
      className="nav-logo"
    />
  </Link>

  <div className="nav-right">
    <nav className={`nav-menu ${isOpen ? "open" : ""}`}>
      <a href="/#about-section" className="nav-item" onClick={() => setIsOpen(false)}>
        About Us
      </a>
      <a
        href="https://loversquarrel.lk"
        target="_blank"
        rel="noreferrer noopener"
        className="nav-item"
        onClick={() => setIsOpen(false)}
      >
        Lovers Quarrel
      </a>
      <a
        href="https://loversquarrel.lk"
        target="_blank"
        rel="noreferrer noopener"
        className="nav-item"
        onClick={() => setIsOpen(false)}
      >
        Sponsors
      </a>
      <Link to="/careers" className="nav-item" onClick={() => setIsOpen(false)}>
        Join Us
      </Link>
      <a
        href="https://www.youtube.com/@RichmondLive-RL/streams"
        target="_blank"
        rel="noreferrer noopener"
        className="nav-cta"
        onClick={() => setIsOpen(false)}
      >
        <span>Watch Live</span>
        <svg viewBox="0 0 1024 1024" className="nav-cta-icon">
          <path d="M342 214l468 298-468 298v-596z"></path>
        </svg>
      </a>
    </nav>

    <div className={`nav-burger ${isOpen ? "active" : ""}`} onClick={toggleMenu}>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</header>

  );
}

export default Navbar;
